import { StyleProp } from "./StyleProp.mjs";
const DefaultTextAlignStyle = StyleProp.defineEnum("tldraw:textAlign", {
  defaultValue: "start",
  values: ["start", "middle", "end"]
});
export {
  DefaultTextAlignStyle
};
//# sourceMappingURL=TLTextAlignStyle.mjs.map
